<template>
  <div class="key-judgment-card">
    <div class="key-judgment-header">
      <div class="key-judgment-title">{{ title }}</div>
    </div>
    <div class="key-judgment-list">
      <div v-for="(item, idx) in parsedJudgments" :key="idx" class="key-judgment-item">
        <div class="key-judgment-index">{{ String(idx + 1).padStart(2, '0') }}</div>
        <div class="key-judgment-content">
          <div class="key-judgment-name">{{ item.title }}</div>
          <div class="key-judgment-desc" v-if="item.description">{{ item.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KeyJudgment',
  props: {
    title: { type: String, default: '' },
    judgments: { type: [Array, String], default: () => [] }
  },
  computed: {
    parsedJudgments() {
      if (Array.isArray(this.judgments)) return this.judgments
      if (typeof this.judgments === 'string') {
        try {
          const parsed = JSON.parse(this.judgments)
          if (Array.isArray(parsed)) return parsed
        } catch (e) { /* ignore */ }
      }
      return []
    }
  }
}
</script>

<style lang="scss" scoped>
.key-judgment-card {
  max-width: 800px;
  padding: 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.key-judgment-header {
  padding: 16px 20px 12px;
}

.key-judgment-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.key-judgment-list {
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.key-judgment-item {
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  background: #F7F8FC;
  border-radius: 8px;
}

.key-judgment-index {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background: #4e8cff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.key-judgment-content {
  flex: 1;
  min-width: 0;
}

.key-judgment-name {
  font-size: 12px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.5;
  margin-bottom: 4px;
}

.key-judgment-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.6;
}
</style>
